module.exports = __webpack_public_path__ + "img/logo_google.b4002e70.png";